import React, { createContext } from 'react';

import { OverrideRegistry } from '../createOverrideRegistry';

export const OverrideContext = createContext<OverrideRegistry | null>(null);

export const OverrideProvider: React.FC<{
  registry: OverrideRegistry;
  children: React.ReactNode;
}> = ({ registry, children }) => <OverrideContext.Provider value={registry}>{children}</OverrideContext.Provider>;
